import { useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import { createOrganization, getCities } from "apis/OrganizationServiceApi";
import CreateOrganizationcss from "./CreateOrganization.module.css";
import { PrimaryContactInfo } from "../FormSections/PrimaryContactInfo/PrimaryContactInfo";
import { BasicOrgInfo } from "../FormSections/BasicOrgInfo/BasicOrgInfo";
import { OrgCharacteristics } from "../FormSections/OrgCharacteristics/OrgCharacteristics";
import { BusinessIdentification } from "../FormSections/BusinessIdentification/BusinessIdentifaction";
import { VerificationDoc } from "../FormSections/VertificationDoc/VertificationDoc";
import { ContinueButton } from "../../Events/CreateEvent.styles";
import { submitOrganizationDocuments } from "apis/OrganizationServiceApi";
import { Organization } from "types";
import UploadOverlay from "components/UploadOverlay/UploadOverlay";
import { Snackbar, Alert } from "@mui/material";

function CreateOrganization() {
  /* ======= STATE needed by the backend ======= */
  const [orgName, setOrgName] = useState("");
  const [email, setEmail] = useState("");
  const [orgInsta, setOrgInsta] = useState("");
  const [orgFace, setOrgFace] = useState("");
  const [orgImage, setOrgImage] = useState("");
  const [orgType, setOrgType] = useState("");
  const [orgIndustry, setOrgIndustry] = useState("");
  const [orgSize, setOrgSize] = useState("");
  const [orgCity, setOrgCity] = useState(1);
  const [legalOrgName, setLegalOrgName] = useState("");
  const [status, setStatus] = useState("");
  const [regesiterNum, setRegesiterNum] = useState("");
  const [geoArea, setGeoArea] = useState("");
  const [ein, setEin] = useState("");
  const [dnb, setDnb] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [orgState, setOrgState] = useState("");
  const [country, setCountry] = useState("");
  const [foundationDate, setFoundationDate] = useState("");
  const [naicsCode, setNaicsCode] = useState("");
  const [ntee, setNtee] = useState("");
  const [description, setDescription] = useState("");
  const [utilityBillFile, setUtilityBillFile] = useState<File | null>(null);
  const [orgCOFFile, setOrgCOFFile] = useState<File | null>(null);
  const [determinationLetterFile, setDeterminationLetterFile] =
    useState<File | null>(null);
  const [orgBusinessLicensesFile, setOrgBusinessLicensesFile] =
    useState<File | null>(null);
  const [orgTaxReturnsFile, setOrgTaxReturnsFile] = useState<File | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const [errorSnack, setErrorSnack] = useState({
    open: false,
    msg: "",
  });
  const handleCloseSnack = () => setErrorSnack({ open: false, msg: "" });

  const selectedFiles = [
    utilityBillFile,
    orgCOFFile,
    determinationLetterFile,
    orgBusinessLicensesFile,
    orgTaxReturnsFile,
  ].filter(Boolean);

  const FILE_COUNT = selectedFiles.length || 1;
  const [uploadStep, setUploadStep] = useState(0);
  const nteeFinal = ntee.trim().toUpperCase().slice(0, 5);
  /* ======= STATE _NOT_ required now ======= */
  // const [name, setName] = useState("");               // ❌ BACKEND NOT USED – commented for now
  // const [phone, setPhone] = useState("");             // ❌ BACKEND NOT USED – commented for now
  // const [website, setWebsite] = useState("");         // ❌ BACKEND NOT USED – commented for now
  // const [orgYoutube, setOrgYoutube] = useState("");   // ❌ BACKEND NOT USED – commented for now
  // const [orgTikTok, setOrgTikTok] = useState("");     // ❌ BACKEND NOT USED – commented for now
  // const [orgTwitter, setOrgTwitter] = useState("");   // ❌ BACKEND NOT USED – commented for now
  // const [beneficiaries, setBeneficiaries] = useState("");      // ❌ BACKEND NOT USED – commented for now
  // const [directorsData, setDirectorData] = useState<{ id: string; name: string; phoneNumber: number }[]>([]); // ❌
  // const [trusteeData, setTrusteeData] = useState<{ id: string; name: string; phoneNumber: number }[]>([]);     // ❌

  const [cities, setCities] = useState<{ id: number; name: string }[]>([]);

  useEffect(() => {
    getCities().then(setCities).catch(console.error);
  }, []);
  const orgCreationToken = uuid();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const nineDigits = /^\d{9}$/;
    if (
      !nineDigits.test(regesiterNum) ||
      !nineDigits.test(ein) ||
      !nineDigits.test(dnb)
    ) {
      setErrorSnack({
        open: true,
        msg: "Registration number, EIN and DNB must have exactly 9 numerical digits.",
      });
      setIsUploading(false);
      return;
    }

    setIsUploading(true);

    setIsUploading(true);
    setUploadStep(0);
    try {
      const uploadIfExists = async (
        file: File | null,
        fileFor: string
      ): Promise<string> => {
        if (!file) {
          console.log(`${fileFor} file is null`);
          return "";
        }

        const res = await submitOrganizationDocuments(
          orgCreationToken,
          fileFor,
          file
        );
        setUploadStep((s) => s + 1);
        const data = res.data;
        const url = data.fileId || "";
        return url;
      };

      const utilityBillUrl = await uploadIfExists(
        utilityBillFile,
        "utility_bill"
      );
      console.log("file 1 Upload");
      const orgCOFUrl = await uploadIfExists(
        orgCOFFile,
        "org_certification_of_formation"
      );
      console.log("file 2 Upload");
      const determinationLetterUrl = await uploadIfExists(
        determinationLetterFile,
        "org_determination_letter"
      );
      console.log("file 3 Upload");
      const orgBusinessLicensesUrl = await uploadIfExists(
        orgBusinessLicensesFile,
        "org_business_licenses"
      );
      console.log("file 4 Upload");
      const orgTaxReturnsUrl = await uploadIfExists(
        orgTaxReturnsFile,
        "org_tax_returns"
      );
      console.log("file 5 Upload");
      /* location in required array-string format */
      const org_location = JSON.stringify([streetAddress, orgState, country]);

      const payload: Organization = {
        org_name: orgName,
        org_email: email,
        org_creation_token: orgCreationToken,

        org_instagram_handle: orgInsta,
        org_facebook_profile: orgFace,
        org_image: orgImage || "",

        org_type: orgType,
        org_industry: orgIndustry,
        org_size: orgSize,
        org_city: Number(orgCity),

        org_legal_name: legalOrgName,
        org_registration_status: status,
        org_registration_number: regesiterNum,
        org_geographic_area: geoArea,
        org_ein: ein,
        org_dnb_number: dnb,

        org_location,
        org_foundation_date: foundationDate,
        org_naics_code: naicsCode,
        org_ntee_code: nteeFinal,

        org_description: description,

        org_utility_bill: utilityBillUrl,
        org_certification_of_formation: orgCOFUrl,
        org_determination_letter: determinationLetterUrl,
        org_business_licenses: orgBusinessLicensesUrl,
        org_tax_returns: orgTaxReturnsUrl,
      };
      const response = await createOrganization(payload);
      if(response?.message){
        alert(response.message);
      }
    } catch (err) {
      console.error("Error on onSubmit:", err);
      alert("An error ocurred when creating the organization.");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <>
      <UploadOverlay open={isUploading} step={uploadStep} total={FILE_COUNT} />

      <form className={CreateOrganizationcss.formContainer} onSubmit={onSubmit}>
        <input
          type="hidden"
          name="org_creation_token"
          value={orgCreationToken}
        />

        <h1 className={CreateOrganizationcss.createOrgLabel}>
          Create an Organization
        </h1>

        {/* PrimaryContactInfo only needed for email */}
        <PrimaryContactInfo
          /* setName={setName}           ❌ BACKEND NOT USED – commented for now */
          /* setPhone={setPhone}         ❌ BACKEND NOT USED – commented for now */
          setEmail={setEmail}
        />

        <BasicOrgInfo
          setOrgName={setOrgName}
          setStreetAddress={setStreetAddress}
          setOrgCity={(v) =>
            setOrgCity(Number(v))
          } /* setWebsite={setWebsite} ❌ BACKEND NOT USED – commented for now */
          setOrgInsta={setOrgInsta}
          /* setOrgYoutube={setOrgYoutube} ❌ BACKEND NOT USED – commented for now */
          /* setOrgTwitter={setOrgTwitter} ❌ BACKEND NOT USED – commented for now */
          /* setOrgTikTok={setOrgTikTok} ❌ BACKEND NOT USED – commented for now */
          setOrgFace={setOrgFace}
          setOrgState={setOrgState}
          setCountry={setCountry}
          setOrgImage={setOrgImage}
          setDescription={setDescription}
          cities={cities}
        />

        <OrgCharacteristics
          setFoundationDate={setFoundationDate}
          setOrgType={setOrgType}
          orgType={orgType}
          setOrgIndustry={setOrgIndustry}
          setOrgSize={setOrgSize}
          setNaicsCode={setNaicsCode}
        />

        <BusinessIdentification
          setGeoArea={setGeoArea}
          setRegesiterNum={setRegesiterNum}
          setLegalOrgName={setLegalOrgName}
          setDnb={setDnb}
          setEin={setEin}
          setNtee={setNtee}
          setStatus={setStatus}
        />

        <VerificationDoc
          orgCreationToken={orgCreationToken}
          setUtilityBill={setUtilityBillFile}
          setOrgCOF={setOrgCOFFile}
          setDeterminationLetter={setDeterminationLetterFile}
          setOrgBusinessLicenses={setOrgBusinessLicensesFile}
          setOrgTaxReturns={setOrgTaxReturnsFile}
        /* setBeneficiaries={setBeneficiaries}   ❌ BACKEND NOT USED – commented for now */
        /* directorsData={directorsData}       ❌ BACKEND NOT USED – commented for now */
        /* setDirectorData={setDirectorData}    ❌ BACKEND NOT USED – commented for now */
        /* trusteeData={trusteeData} ❌ BACKEND NOT USED – commented for now */
        /* setTrusteeData={setTrusteeData}   ❌ BACKEND NOT USED – commented for now */
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "20px",
          }}
        >
          <ContinueButton type="submit" disabled={isUploading}>
            {isUploading ? "Uploading files..." : "Submit"}
          </ContinueButton>
        </div>
      </form>
      <Snackbar
        open={errorSnack.open}
        autoHideDuration={6000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnack}
          severity="warning"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {errorSnack.msg}
        </Alert>
      </Snackbar>
    </>
  );
}

export default CreateOrganization;
